import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'app.createEmail.title',
    defaultMessage: 'Create email',
    description: 'Create email drawer title',
  },
  fields: {
    from: {
      id: 'properties.from',
      defaultMessage: 'From',
      description: 'label of the from field button',
    },
  },
  confirmSaveAsConcept: {
    title: {
      id: 'app.confirmSaveEmailAsConcept.title',
      defaultMessage: 'Save as concept?',
      description: 'title of the save as concept dialog confirm',
    },
    description: {
      id: 'app.confirmSaveEmailAsConcept.description',
      defaultMessage:
        "This email hasn't been submitted and contains changes that aren't saved. You can save the email as a concept and edit it later.",
      description: 'description of the save as concept dialog confirm',
    },
    buttons: {
      discard: {
        id: 'actions.discard',
        defaultMessage: 'Discard',
        description: 'label of the discard button',
      },
      cancel: {
        id: 'actions.cancel',
        defaultMessage: 'Cancel',
        description: 'label of the cancel button',
      },
      save: {
        id: 'actions.save',
        defaultMessage: 'save',
        description: 'label of the save button',
      },
    },
  },
};

export default defineMessages(translations);
